import * as React from 'react';
import {ReactSVG} from "react-svg";
import {useSelector} from "react-redux";
import {has} from "lodash";
import * as moment from 'moment';
import {hstatic, staticHypotheekbondUrl} from "@dnhb/node_package";
import useCurrentRoute from "../../hooks/useCurrentRoute";
import {RootState} from "../../redux/store";
import {RowContainer, SkeletonLoader} from "../Containers";
import {Separator} from "../Content";
import {ArticleContext} from "./ArticleCard";
import ArticleTopics from "./ArticleTopics";
import {INITIAL_ROUTE} from "../../hooks/useRoutes";
import useMedia from "../../hooks/useMedia";
moment.locale('nl');

interface Props {
  className?: string;
  size?: number;
  compact?: boolean;
  style?: {[key: string]: number|string}
}

const ArticleMeta: React.FC<Props> = ({
  size = 7,
  style,
  compact = true,
  ...props
}): React.ReactElement => {
  const pathname = useCurrentRoute();
  const {onMobile} = useMedia();
  const {articles_visible} = useSelector((state: RootState) => {
    const {routes} = state.application;
    const route = has(routes, pathname) ? routes[pathname] : INITIAL_ROUTE;
    const {articles_visible} = route;

    return {
      articles_visible: (articles_visible || []),
    }
  });
  let visible;

  return (
    <ArticleContext.Consumer>
      {({content: {id: uuid, publishedTime, visible: isVisible}}) => {
        const published = publishedTime ? moment(publishedTime) : false;
        visible = isVisible || (articles_visible || []).find(id => id === String(uuid));

        return visible && published ? (
          <RowContainer style={{width: '100%', flexFlow: onMobile ? 'row wrap' : 'row nowrap', alignItems: 'center', ...style}} {...props}>
            {!compact && (
              <span className={`f-${size} fw-600`} style={{display: 'flex', flex: 0}}>
                <ArticleTopics size={7} compact={!compact} />
                <Separator />
              </span>
            )}

            <span className={`f-${size} fw-600`} style={{display: 'flex'}}>
              {
                !compact
                  ? (`${published.format('DD MMM YYYY')}`)
                  : (
                      <ReactSVG
                        src={hstatic(`${staticHypotheekbondUrl()}images/icon/clock.svg`)}
                        style={{padding: '0 4px 0 2px', marginTop: '1px'}}
                      />
                    )
              }
              {compact && `${published.format('DD MMM')}, ${published.format('HH:mm')}`}

              {!compact && (<Separator />)}
              {!compact && (
                <ReactSVG
                  src={hstatic(`${staticHypotheekbondUrl()}images/icon/clock.svg`)}
                  style={{padding: '0 4px 0 2px', marginTop: '1px'}}
                />
              )}
              {!compact && ` ${published.format('HH:mm')}`}
            </span>
          </RowContainer>
        ) : (
          <SkeletonLoader {...props} />
        )
      }}
    </ArticleContext.Consumer>
  )
}

export default ArticleMeta;
